import { render, staticRenderFns } from "./ModalPageLocalArmazenamento.vue?vue&type=template&id=2444f350"
import script from "./ModalPageLocalArmazenamento.vue?vue&type=script&lang=js"
export * from "./ModalPageLocalArmazenamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports